var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderReceipt',{attrs:{"header":"สินค้ารอย้ายเข้าคลังใกล้หมดอายุ","img_header":_vm.header_image,"link_back":"stock/storage/mainstorage"}}),_c('Storage_exp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }